module.exports = __webpack_public_path__ + "static/favicon-ebdce2a2a4a8f46a248e812bd2a98a30.png";